import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IntlMessages from 'Util/IntlMessages';
import { collapsedNotificationSidebarAction } from 'Actions/AppSettingsActions';
import { dateFormat, getDateWithDayNameDashFormatMoment, hourFormat } from 'Util/DateUtils';
import { postNoty } from 'Api/endpoints/User';
import { useError } from 'Api/hooks/useError';

const Item = ({ item, index, getCategoryData, notifications }) => {
  const dispatch = useDispatch();
  const { locale } = useSelector(state => state.settings.locale);

  const prevDate = dateFormat(notifications[index - 1]?.dateCreated, locale);
  const isSameDate = prevDate === dateFormat(item.dateCreated, locale);
  const categoryData = getCategoryData(item);
  const { showErrorPopup } = useError();

  const handleClick = async () => {
    categoryData.onClick();
    dispatch(collapsedNotificationSidebarAction(true));
    try {
      const result = await postNoty(item._id);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {!isSameDate && (
        <div className="notification-sidebar-content-list-item-date">
          {getDateWithDayNameDashFormatMoment(item.dateCreated, locale)}
          <div className="notification-sidebar-content-list-item-date-line" />
        </div>
      )}
      <div className={`notification-sidebar-content-list-item ${!item.read && 'unread'} cursor-pointer no-drag`} onClick={handleClick}>
        <div className="notification-sidebar-content-list-item-icon">
          <img {...categoryData.icon} alt="icon" style={{ width: '18px', height: '18px' }} />
        </div>
        <div className="notification-sidebar-content-list-item-content">
          <div className="notification-sidebar-content-list-item-content-header">
            <div className="notification-sidebar-content-list-item-content-header-title">
              <div className="notification-sidebar-content-list-item-content-header-title-text">
                <IntlMessages id={categoryData.labelId} />
              </div>
              {!item.read && <div className="notification-sidebar-content-list-item-content-header-title-dot" />}
            </div>
            <div className="notification-sidebar-content-list-item-content-header-time">{hourFormat(item.dateCreated, locale)}</div>
          </div>
          {item.title && <div className="notification-sidebar-content-list-item-content-title">{item.title}</div>}
          {item.body && <div className="notification-sidebar-content-list-item-content-body">{item.body}</div>}
        </div>
      </div>
    </>
  );
};

export default Item;
